
export const categories = [
  { id: '1', name: 'Electronics', slug: 'electronics', icon: 'ri-smartphone-line' },
  { id: '2', name: 'Fashion', slug: 'fashion', icon: 'ri-shirt-line' },
  { id: '3', name: 'Furniture', slug: 'furniture', icon: 'ri-sofa-line' },
  { id: '4', name: 'Vehicles', slug: 'vehicles', icon: 'ri-car-line' },
  { id: '5', name: 'Real Estate', slug: 'real-estate', icon: 'ri-home-line' },
  { id: '6', name: 'Jobs', slug: 'jobs', icon: 'ri-briefcase-line' },
  { id: '7', name: 'Services', slug: 'services', icon: 'ri-tools-line' }
];

export const locations = [
  'Lagos, Lagos',
  'Abuja, FCT',
  'Kano, Kano',
  'Ibadan, Oyo',
  'Port Harcourt, Rivers',
  'Benin City, Edo',
  'Maiduguri, Borno',
  'Zaria, Kaduna',
  'Aba, Abia',
  'Jos, Plateau',
  'Ilorin, Kwara',
  'Onitsha, Anambra',
  'Kaduna, Kaduna',
  'Katsina, Katsina',
  'Bauchi, Bauchi',
  'Akure, Ondo',
  'Makurdi, Benue',
  'Minna, Niger',
  'Efon-Alaaye, Ekiti',
  'Gombe, Gombe',
  'Uyo, Akwa Ibom',
  'Abeokuta, Ogun',
  'Sokoto, Sokoto',
  'Enugu, Enugu',
  'Warri, Delta',
  'Calabar, Cross River',
  'Kogi, Kogi',
  'Dutse, Jigawa',
  'Birnin Kebbi, Kebbi',
  'Jalingo, Taraba',
  'Lafia, Nasarawa',
  'Ikeja, Lagos',
  'Yenagoa, Bayelsa',
  'Damaturu, Yobe',
  'Gusau, Zamfara',
  'Owerri, Imo',
  'Awka, Anambra',
  'Asaba, Delta',
  'Abakaliki, Ebonyi',
  'Ado-Ekiti, Ekiti',
  'Osogbo, Osun',
  'Yola, Adamawa',
  'Lokoja, Kogi',
  'Oshogbo, Osun',
  'Sagamu, Ogun',
  'Ogbomoso, Oyo',
  'Okene, Kogi',
  'Sapele, Delta',
  'Offa, Kwara',
  'Ikot Ekpene, Akwa Ibom'
];
